import { PASSWORD_REG_EXP } from '@constant'

export const passwordRegExp = string => {
  if (string) {
    if (!(string.length >= 8 && string.length <= 20)) {
      return '密码长度为8-20位！'
    } else if (!PASSWORD_REG_EXP.test(string)) {
      return '必须包含字母、数字！'
    }
  }
}
